<template>
	<div>
		<div
			class="tp-cardv-main relativeclass"
			@click="topicDetails.active ? goToTest() : ''"
			:class="
				selTopic == topicDetails.topicID
					? 'changecolor'
					: topicDetails.active
					? 'pointer'
					: 'defaultCursor'
			"
		>
			<div class="tp-cardhead">
				<div style="width: 70%" class="relativeclass">
					<div
						v-if="topicDetails.active"
						class="tp-text d-flex align-items-center"
					>
						<div v-if="topicDetails.active" class="mt-1">
							<img src="../../../assets/active.svg" alt="" class="" />
						</div>
						<div
							v-b-popover.hover.top="topicDetails.name"
							style="max-width: 100%"
							class="d-inline-block text-truncate ml-1 mt-1"
						>
							{{ topicDetails.name }}
						</div>
					</div>
					<div v-else class="tp-text d-flex align-items-center ellipsis">
						<span class="mt-1"
							><img src="../../../assets/inactive.svg" alt="" class=""
						/></span>
						<span
							v-b-popover.hover.top="topicDetails.name"
							style="max-width: 100%"
							class="d-inline-block text-truncate ml-1 mt-1"
						>
							{{ topicDetails.name }}
						</span>
					</div>
				</div>
				<div
					class="tp-cardoptions d-flex justify-content-end"
					v-if="!topicDetails.active"
					@click.stop=""
				>
					<div
						v-if="roles.includes('ACTIVATE_TOPIC')"
						v-b-popover.hover.top="'Activate'"
						@click="copyingVal()"
						class="pointer mr-1"
					>
						<img src="../../../assets/activate.svg" alt="" />
					</div>
				</div>

				<div v-if="topicDetails.active" @click.stop="">
					<div
						class="tp-cardoptions d-flex justify-content-end"
						style="width: 30%"
						v-if="!topicDetails.editoption"
					>
						<img
							v-if="
								roles.includes('PUT_TOPIC') || roles.includes('DELETE_TOPIC')
							"
							@click="$emit('card-option', topicDetails.topicID, true)"
							src="../../../assets/ellipseicon.svg"
							alt=""
							class="m-1 pointer"
							v-b-popover.hover.top="'View More'"
						/>
					</div>

					<transition name="slide-fade">
						<div
							class="tp-cardeditoptions pointer d-flex justify-content-end"
							style="width: 30%"
							v-if="topicDetails.editoption"
						>
							<img
								v-if="roles.includes('PUT_TOPIC')"
								v-b-popover.hover.top="'Edit'"
								@click="copyingVal()"
								src="../../../assets/pencilicon.svg"
								alt=""
								class="m-1"
							/>
							<img
								v-if="roles.includes('DELETE_TOPIC')"
								v-b-popover.hover.top="'Delete'"
								@click="
									(deleteModal = !deleteModal),
										(selTopic = topicDetails.topicID)
								"
								src="../../../assets/deleteicon.svg"
								alt=""
								class="m-1"
							/>

							<img
								src="../../../assets/closeicon.svg"
								v-b-popover.hover.top="'Close'"
								alt=""
								class="m-1"
								@click="$emit('card-option', null, true)"
							/>
						</div>
					</transition>
				</div>
			</div>

			<div
				v-if="topicDetails.active"
				class="tp-card-content"
				:id="topicDetails.topicID"
			>
				<div
					class="text-truncate w-100"
					v-if="topicDetails.description.length > 0"
				>
					<span
						v-b-popover.hover.bottom="topicDetails.description"
						style="max-width: 100%"
						class="d-inline-block text-truncate"
					>
						{{ topicDetails.description }}
					</span>
				</div>
				<div
					v-if="topicDetails.description.length == 0"
					class="d-flex align-items-center justify-content-center"
				>
					<div><img src="../../../assets/nodataicon.svg" alt="" /></div>
					<div class="nodatatext">Description not available</div>
				</div>

				<!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dui diam ac pulvinar nisl senectus eu pulvinar...... -->
			</div>
			<div v-else class="tp-card-content" :id="topicDetails.topicID">
				<div v-if="topicDetails.description.length > 0">
					<span
						v-b-popover.hover.bottom="topicDetails.description"
						style="max-width: 100%"
						class="d-inline-block text-truncate"
					>
						{{ topicDetails.description }}
					</span>
				</div>
				<div
					v-if="topicDetails.description.length == 0"
					class="d-flex align-items-center justify-content-center"
				>
					<div><img src="../../../assets/nodataicon.svg" alt="" /></div>
					<div class="nodatatext">Description not available</div>
				</div>

				<!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dui diam ac pulvinar nisl senectus eu pulvinar...... -->
			</div>

			<div
				v-if="topicDetails.active"
				class="tp-cardv-submain d-flex justify-content-around d-flex align-items-center pt-4 pb-4"
			>
				<div
					class="d-flex align-items-center flex-column"
					v-b-popover.hover.top="'No. of tests count'"
				>
					<span v-if="topicDetails.testCount < 10" class="greennumbertext"
						>0{{ topicDetails.testCount }}</span
					>
					<span v-else class="greennumbertext">
						{{ topicDetails.testCount }}</span
					>
					<span class="tp-cardhead">Tests</span>
				</div>
				<div
					class="d-flex align-items-center flex-column"
					v-b-popover.hover.top="'No. of Candidates taken test'"
				>
					<span v-if="topicDetails.candidateCount < 10" class="yellownumbertext"
						>0{{ topicDetails.candidateCount }}</span
					>
					<span v-else class="yellownumbertext"
						>{{ topicDetails.candidateCount }}
					</span>
					<span class="tp-cardhead">Candidates</span>
				</div>
			</div>
			<div
				v-else
				class="tp-cardv-submain d-flex justify-content-around d-flex align-items-center"
			>
				<div
					class="d-flex align-items-center flex-column"
					v-b-popover.hover.top="'No. of Tests taken'"
				>
					<span
						v-if="topicDetails.inActiveTestCount < 10"
						class="greennumbertext"
						>0{{ topicDetails.inActiveTestCount }}</span
					>
					<span v-else class="greennumbertext">
						{{ topicDetails.inActiveTestCount }}</span
					>
					<span class="tp-cardhead">Tests</span>
				</div>
				<div
					class="d-flex align-items-center flex-column"
					v-b-popover.hover.top="'No. of Candidates taken test'"
				>
					<span v-if="topicDetails.candidateCount < 10" class="yellownumbertext"
						>0{{ topicDetails.candidateCount }}</span
					>
					<span v-else class="yellownumbertext">{{
						topicDetails.candidateCount
					}}</span>
					<span class="tp-cardhead">Candidates</span>
				</div>
			</div>

			<!-- Modals Starts -->

			<!-- Edit PopUp Start   -->
			<EditTopicModal
				:topicDetails="topicDetails"
				:nameEdit="nameEdit"
				:clone="clone"
				:context="this"
			/>

			<ActivateTopicModal
				:theTopicName="theTopicName"
				:totalTestCount="totalTestCount"
				:totalTestArr="totalTestArr"
				:actualres="actualres"
				:context="this"
			/>

			<!-----------------  Delete Popup starts -------->

			<DeleteTopicModal :clone="clone" :context="this" />
			<!-----------------  Delete Popup ends -------->

			<!-- Modals Ends -->
			<div class="d-flex justify-content-center">
				<div class="inactive-text-box" v-if="!topicDetails.active">
					<div class="inactive-txt">Inactive</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import toast from "../../mixin/toast";
import { copyingVal, goToTest } from "@/controllers/topics/helpers";

import EditTopicModal from "@/controllers/topics/Modals/EditModal.vue";
import DeleteTopicModal from "@/controllers/topics/Modals/DeleteModal.vue";
import ActivateTopicModal from "@/controllers/topics/Modals/ActivateModal.vue";

export default {
	name: "TopicCard",
	mixins: [toast],
	props: {
		showindex: Number,
		topicDetails: Object,
		simp: Boolean,
		type: String,
		sort: String,
	},
	components: {
		EditTopicModal,
		DeleteTopicModal,
		ActivateTopicModal,
	},
	data() {
		return {
			nameEdit: "",
			LoaderStatus: false,
			selTopic: "",
			theTopicName: "",
			sortColumn: "createdAt",
			count: "all",
			totalTestCount: 0,
			sortorder: -1,
			page: 0,
			topicModal: false,
			publicAvailability: false,
			active: true,
			deleteModal: false,
			design: false,
			allTestIds: [],
			totalTestArr: [],
			actualres: {},
			clone: { ...this.topicDetails },
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
		};
	},
	validations: {
		clone: {
			name: {
				required,
				maxLength: maxLength(128),
			},
			description: {
				maxLength: maxLength(512),
			},
		},
	},
	computed: {
		...mapGetters(["roles"]),
	},
	methods: {
		copyingVal() {
			copyingVal(this);
		},
		goToTest() {
			goToTest(this);
		},
	},
};
</script>

<style scoped>
.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	width: 302px;
	border-radius: 8px;
	padding: 15px;
}
.inactive-text-box {
	background: #ffeeee;
	border-radius: 3px;
	padding: 4px;
	position: absolute;
	right: 15px;
	bottom: 3px;
	width: 272px;
	text-align: center;
}

.inactive-txt {
	font-weight: 400;
	font-size: 12px;
	color: #ad1927;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(10px);
	opacity: 0;
}

.relativeclass {
	position: relative;
}
.hidebutton.btn-secondary {
	background-color: #fff !important;
	color: black !important;
	border: none;
}
</style>
